module.exports = __webpack_public_path__ + "static/media/Service4image.8460f82a.svg";